module.exports = __webpack_public_path__ + "static/img/wl.8e3b142.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl.png
// module id = Q4bz
// module chunks = 20